<template>
  <generic-modal
    :title="$t('signing profile')"
    ref="generic_modal"
    :is_wide="true"
  >
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>

      <div class="title is-5">{{ $t("document") }}</div>
      <document ref="document" @error="set_error" />
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import Document from "./Document.vue";

export default {
  name: "SigningProfileModal",
  components: { GenericModal, GenericDropdown, Document },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/document-sign/signing-profile", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          if (v.meta.settings.pages)
            v.$refs.document.set_pages(v.meta.settings.pages);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      data.settings.pages = v.$refs.document.get_pages();
      v.$root.loader(true);
      if (!v.meta.uuid)
        put("/document-sign/signing-profile", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
      else
        post("/document-sign/signing-profile", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.$root.loader(false);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.$refs.document.clear();
      v.error = "";
    },
    set_error(error) {
      let v = this;
      v.error = error;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
